import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'markdown-to-jsx';
import { reduxForm, formValues, Field as ReduxFormField } from 'redux-form';

import Field from '@ynap/field';
import { Button } from '@ynap/button';
import BEMHelper from '@ynap/bem-helper';
import Notification from '@ynap/notification';
import { PasswordInput } from '@ynap/password-input';
import { onSubmitFail, submitAndCollateErrorsPromise } from '@ynap/form-utils';

import validate from './validate';
import collateErrors from './collateErrors';
import LoginConsent from './LoginConsent';

const bem = new BEMHelper('LoginForm');

export class LoginForm extends PureComponent {
    static propTypes = {
        form: PropTypes.string,
        submitting: PropTypes.bool,
        handleSubmit: PropTypes.func,
        children: PropTypes.node,
        messages: PropTypes.shape({
            loginForm: PropTypes.shape({
                login: PropTypes.func,
                logonId: PropTypes.func.isRequired,
                logonPassword: PropTypes.func.isRequired,
            }).isRequired,
            errors: PropTypes.shape({
                required: PropTypes.func.isRequired,
                invalid: PropTypes.func.isRequired,
                authenticationError: PropTypes.func.isRequired,
                loginNotAllowed: PropTypes.func.isRequired,
                global: PropTypes.func.isRequired,
            }).isRequired,
        }).isRequired,
        error: PropTypes.string,
        hideLogonId: PropTypes.bool,
        className: PropTypes.string,
    };

    static defaultProps = {
        component: 'form',
        hideLogonId: false,
    };

    componentDidUpdate(prevProps) {
        const { consent, handleSubmit } = this.props;

        /* istanbul ignore else */
        if (consent && !prevProps.consent) {
            handleSubmit((values) => this.submit(values, 450))();
        }
    }

    submit = (values, delay) => {
        const { onSubmit } = this.props;
        return submitAndCollateErrorsPromise(onSubmit(values, undefined, delay), values, this.props);
    };

    render() {
        const { form, component: Component, submitting, handleSubmit, messages, className, error, hideLogonId, locale, children } = this.props;

        return (
            <Component id={form} method="post" className={bem(null, { submitting }, className)} onSubmit={handleSubmit ? handleSubmit(this.submit) : undefined}>
                {error ? (
                    <Notification
                        type="error"
                        className={bem('error')}
                        message={
                            <ReactMarkdown
                                options={{
                                    overrides: {
                                        a: (props) => (
                                            <a
                                                className={bem('errorLink')}
                                                href={locale ? `/${locale.id}${props.href}` : props.href}
                                                rel="noopener noreferrer"
                                            >
                                                {props.children}
                                            </a>
                                        )
                                    },
                                }}
                            >
                                {error}
                            </ReactMarkdown>
                        }
                    />
                ) : null}

                {!hideLogonId ? <Field name="logonId" type="email" label={messages.loginForm.logonId()} autoComplete="username" /> : null}
                {children}
                <Field
                    className={bem('field')}
                    component={PasswordInput}
                    name="logonPassword"
                    label={messages.loginForm.logonPassword()}
                    autoComplete="password"
                />
                <ReduxFormField className={bem('field')} component={LoginConsent} name="externalConsentsProvided" messages={messages} />
                {handleSubmit ? (
                    <Button type="submit" className={bem('submit')} disabled={submitting}>
                        {messages.loginForm.login()}
                    </Button>
                ) : null}
            </Component>
        );
    }
}

export const LoginFormWithValues = formValues({ consent: 'externalConsentsProvided' })(LoginForm);
export default reduxForm({ form: 'login', validate, collateErrors, onSubmitFail })(LoginFormWithValues);
